export default "__VITE_ASSET__yTa9YBUj__"